function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { useCallback, useContext } from 'react';
import KEYCODES from '../../utils/KEYCODES';
import get from '../../utils/get';
import getOr from '../../utils/getOr';
import './withExpandableColumnHeaders.css';
import Button from '../../Buttons/Button/Button';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import ValidationForm from '../../SchemaForm/ValidationForm/ValidationForm';
import { getAdditionalProps } from '../utils';
import cs from 'classnames';
import FilterButton from '../FilterButton';
import FilterBox from '../FilterBox/FilterBox';
import ThemeContext from '../../ThemeContext';
var NONE = 'none';
var getTheadExpandableProps = function getTheadExpandableProps(FilterBoxComponent) {
  return getAdditionalProps('dm-table__cell dm-table__cell--header', function (state, rowInfo, column, instance) {
    return {
      columnId: "".concat(column.id, "-").concat(state.captionId || state.nameSpace),
      formData: column.formData,
      icons: column.icons,
      id: column.id,
      label: column.label,
      onApply: column.onApply,
      schema: column.schema,
      sortable: column.sortable !== false,
      uiSchema: column.uiSchema,
      validate: column.validate,
      width: column.width,
      FilterBoxComponent: FilterBoxComponent
    };
  });
};
function getNormalized(getter) {
  return function (e) {
    var result = getter(e);
    return result ? result.toLowerCase() : result;
  };
}
var getTagName = getNormalized(get('target.tagName'));
var getType = getNormalized(getOr('text')('target.type'));
function FilterForm(_ref) {
  var formData = _ref.formData,
    isValid = _ref.isValid,
    onApply = _ref.onApply,
    onChange = _ref.onChange,
    onValidate = _ref.onValidate,
    schema = _ref.schema,
    uiSchema = _ref.uiSchema,
    validate = _ref.validate;
  var theme = useContext(ThemeContext);
  var handleKeyPress = useCallback(function (e) {
    if (e.which === KEYCODES.ENTER && 'input' === getTagName(e) && ['text', 'date'].includes(getType(e))) {
      onApply();
    }
  }, [onApply]);
  return /*#__PURE__*/React.createElement("div", {
    onKeyPress: handleKeyPress,
    className: "dm-table__header-filter-container"
  }, /*#__PURE__*/React.createElement(ValidationForm, {
    formData: formData,
    onChange: onChange,
    onValidate: onValidate,
    schema: schema,
    size: "small",
    uiSchema: uiSchema,
    validate: validate,
    validateDirtyOnly: false
  }), /*#__PURE__*/React.createElement("div", {
    className: "dm-table__filter-header-apply"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: "@dm/components.table.error-apply-disabled",
    neverShow: isValid
  }, function (_ref2) {
    var ref = _ref2.ref,
      describedby = _ref2.describedby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      modifier: theme === 'ripple' ? 'primary' : undefined,
      ref: ref,
      "aria-describedby": describedby,
      onClick: onApply,
      disabled: !isValid
    }, events), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: "Apply"
    }));
  })));
}
var ThExpandableComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ThExpandableComponent, _React$Component);
  function ThExpandableComponent(props) {
    var _this;
    _classCallCheck(this, ThExpandableComponent);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThExpandableComponent).call(this, props));
    _this.componentDidUpdate = function (prevProps) {
      if (prevProps.formData === undefined || _this.props.formData === undefined) {
        return;
      }
      var prevFormData = Object.assign({}, prevProps.formData);
      var currFormData = Object.assign({}, _this.props.formData);
      var areEqual = Object.keys(prevFormData).length === Object.keys(currFormData).length && Object.keys(prevFormData).every(function (key) {
        return currFormData.hasOwnProperty(key) && currFormData[key] === prevFormData[key];
      });
      if (!areEqual) {
        _this.setState({
          formData: currFormData
        });
      }
    };
    _this.handleChange = function (formData) {
      _this.setState({
        formData: formData
      });
    };
    _this.handleApply = function (closeMenu) {
      setTimeout(function () {
        var _this$props = _this.props,
          id = _this$props.id,
          label = _this$props.label,
          onApply = _this$props.onApply;
        var _this$state = _this.state,
          formData = _this$state.formData,
          isValid = _this$state.isValid;
        if (isValid) {
          onApply({
            formData: formData,
            accessor: id,
            label: label
          });
          closeMenu();
        }
      }, 150);
    };
    _this.handleValidate = function (isValid) {
      _this.setState({
        isValid: isValid
      });
    };
    _this.renderFilterBox = function (closeMenu) {
      var _this$props2 = _this.props,
        schema = _this$props2.schema,
        uiSchema = _this$props2.uiSchema,
        validate = _this$props2.validate;
      var _this$state2 = _this.state,
        formData = _this$state2.formData,
        isValid = _this$state2.isValid;
      return /*#__PURE__*/React.createElement(FilterForm, {
        formData: formData,
        isValid: isValid,
        onApply: function onApply() {
          return _this.handleApply(closeMenu);
        },
        onChange: _this.handleChange,
        onValidate: _this.handleValidate,
        schema: schema,
        uiSchema: uiSchema,
        validate: validate
      });
    };
    _this.state = {
      formData: props.formData,
      isValid: true
    };
    return _this;
  }
  _createClass(ThExpandableComponent, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        FilterBoxComponent = _this$props3.FilterBoxComponent,
        icons = _this$props3.icons,
        sortable = _this$props3.sortable,
        columnId = _this$props3.columnId,
        width = _this$props3.width;
      var styl = width ? {
        width: width
      } : undefined;
      return sortable ? /*#__PURE__*/React.createElement("span", {
        "aria-readonly": "true",
        "aria-sort": this.state.formData.sort || NONE,
        className: cs(className, 'dm-table__filter-header'),
        role: "columnheader",
        style: styl
      }, /*#__PURE__*/React.createElement(FilterButton, {
        FilterBoxComponent: FilterBoxComponent,
        columnId: columnId,
        icons: icons,
        label: React.Children.toArray(children)[0].props.children
      }, this.renderFilterBox)) : /*#__PURE__*/React.createElement("span", {
        "aria-readonly": "true",
        className: className,
        role: "columnheader",
        style: styl
      }, React.Children.toArray(children)[0].props.children);
    }
  }]);
  return ThExpandableComponent;
}(React.Component);
export default function withExpandableColumnHeaders(props) {
  var FilterBoxComponent = props && props.FilterBoxComponent || FilterBox;
  return function (TableComponent) {
    return function (props) {
      return /*#__PURE__*/React.createElement(TableComponent, Object.assign({
        ThComponent: ThExpandableComponent,
        getTheadThProps: getTheadExpandableProps(FilterBoxComponent)
      }, props));
    };
  };
}